import { useEffect, useState } from 'react';
import { CountryType } from '../types';
import { apiUrl } from '../constants';

type Props = {
  other: Array<CountryType>;
  popular: Array<CountryType>;
};

const isDev = process.env.NODE_ENV === 'development';

const useGetCountries = () => {
  const [countries, setCountries] = useState<Props>();

  useEffect(() => {
    const fetchCountries = async () => {
      const response = await fetch(
        isDev ? apiUrl + '/api/helper/countries' : '/api/helper/countries'
      );
      const json = await response.json();
      setCountries(json);
    };
    fetchCountries();
  }, []);
  return { countries };
};

export default useGetCountries;
